const Config = {
  API_KEY: 'xUXLYeLrHI3xF5eyAMmkQ6L9s85f5JNA80dg4o5m',
  Pool: {
    UserPoolId: 'ap-southeast-1_Plk3zm2SJ',
    ClientId: '7530ag3evaud0ahlqf14ljk3de'
  }
};
  
export default Config;
